// Every process.env read lives here, and nowhere else.
// Note: the tenant is deliberately absent — it is resolved per request from the
// `tenant_id` query param, not from a build-time constant.

export const NEXT_PUBLIC_SHOP_API_URL = process.env.NEXT_PUBLIC_SHOP_API_URL || ''

export const NEXT_PUBLIC_SHOP_SITE_NAME = process.env.NEXT_PUBLIC_SHOP_SITE_NAME || 'Shop'

// Unset by default (feature is inert): the shared host every tenant subdomain is a
// sibling of (e.g. "shop.storims.com"). When unset, subdomain resolution never
// fires — see resolve-subdomain.ts. The real production value is a deployment
// decision for later.
export const NEXT_PUBLIC_SHOP_SHARED_HOST = process.env.NEXT_PUBLIC_SHOP_SHARED_HOST || ''

